// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__qbz0B","sm":"Avatar_sm__jNnHA","lg":"Avatar_lg__Jm2hc","xl":"Avatar_xl__2Bnup"};